/* src/app/shared/components/flow-segment-control/flow-segment-control.component.scss */
.segment-control {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background-color: #f4f4f5;
  box-sizing: border-box;
}
.segment-control__indicator {
  position: absolute;
  top: 4px;
  left: 0;
  bottom: 4px;
  border-radius: 8px;
  background-color: #4568d0;
  opacity: 0;
  pointer-events: none;
  transition:
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.15s ease-out;
}
.segment-control__indicator--visible {
  opacity: 1;
}
.segment-control .segment {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  color: #3f3f46;
  border-radius: 8px;
  white-space: nowrap;
  transition: color 0.25s ease-out;
}
.segment-control .segment:hover:not(.selected):not(.disabled) {
  background-color: #e4e4e7;
}
.segment-control .segment.selected {
  color: #ffffff;
}
.segment-control .segment.selected span {
  color: #ffffff;
}
.segment-control .segment.disabled {
  cursor: not-allowed;
  color: #a1a1aa;
}
.segment-control.medium .segment {
  height: 32px;
}
.segment-control.large .segment {
  height: 40px;
}
/*# sourceMappingURL=flow-segment-control.component.css.map */
